import React from "react";

import "./Footer.css";
import SocialIcons from "./SocialIcons";
import Logo from "assets/image/Logo";
import LogoMobileFooter from "assets/image/LogoMobileFooter";
import LogoTablet from "assets/image/LogoTablet";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="logo-container" aria-hidden="true">
          <Logo className="desktop-logo-footer" />
          <LogoMobileFooter className="mobile-logo-footer" />
          <LogoTablet className="tablet-logo-footer" />
        </div>

        <div className="social-icons">
          <SocialIcons />
          <div className="footer-copyright">
            © 2025 All rights reserved to Sullabread
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
